/**
 * DiscardDialog — Bestätigungsdialog für „Verwerfen" mit optionalem Grund (Q5).
 * Muster `ApplyGlobalConfirmDialog.tsx` (kontrolliertes `open`, kein DialogTrigger).
 */
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, Button, Textarea } from '@/components/v2/ui'
import { EID } from '@/lib/element-ids.registry'

export interface DiscardDialogProps {
  open: boolean
  busy?: boolean
  onConfirm: (reason?: string) => void
  onCancel: () => void
}

export function DiscardDialog({ open, busy = false, onConfirm, onCancel }: DiscardDialogProps) {
  const { t } = useTranslation()
  const [reason, setReason] = useState('')

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t('channelContent.discard.title')}</DialogTitle>
        </DialogHeader>

        <Textarea
          id={EID['text-bulk-review-discard-dialog-reason-input']}
          label={t('channelContent.discard.reasonLabel')}
          placeholder={t('channelContent.discard.reasonPlaceholder')}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={2}
        />

        <DialogFooter className="flex gap-2">
          <Button
            id={EID['text-bulk-review-discard-dialog-cancel-btn']}
            variant="ghost"
            onClick={onCancel}
            disabled={busy}
          >
            {t('common.cancel')}
          </Button>
          <Button
            id={EID['text-bulk-review-discard-dialog-confirm-btn']}
            variant="destructive"
            onClick={() => onConfirm(reason.trim() || undefined)}
            disabled={busy}
          >
            {t('channelContent.discard.confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
